import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { CommonService } from '../../services/common.service';
import { AuthService } from '../../modules/authentication/services/auth.service';

@Component({
  selector: 'vrm-supervision-sso',
  templateUrl: './supervision-sso.component.html',
  styleUrls: ['./supervision-sso.component.scss'],
})
export class SupervisionSsoComponent implements OnInit {
  ssoFailed: boolean = false;
  signInDone: boolean = false;

  constructor(
    private activatedRoute: ActivatedRoute,
    private authService: AuthService,
    public cService: CommonService
  ) {}

  ngOnInit() {
    console.log(':: VRM INFO: Supervision SSO Component');
    // Clear existing token in case user did not logout.
    // This ensures that the newly issued SSO Token is used.
    this.authService.quickLogout(true, () => {
      this.activatedRoute.params.subscribe({
        next: (params: { uuid: string }) => {
          if (params.uuid) {
            this.cService.showToast('Logging in...');
            this.performLoginWithUuidAuthorizationCode(params.uuid);
          } else {
            console.error(':: VRM ERROR: Auth code cannot be empty');
            this.loginFailed();
          }
        },
      });
    });
  }

  private performLoginWithUuidAuthorizationCode(uuid: string) {
    this.authService.supervisionSsoLogin(uuid).subscribe({
      next: (response) => {
        this.signInDone = true;
        this.authService.navigateToDefaultPage(response.startPage, this.cService.reloadAndTryToApplyUpdates);
      },
      error: () => {
        this.loginFailed();
      },
    });
  }

  private loginFailed() {
    this.ssoFailed = true;
    this.cService.showToast(':: Unable to process login');
  }
}
